<template>
  <div class="sports_item_detail">
    <Empty description="加载中..." v-if="itemDetail == ''" />
    <div class="body" v-else>
      <mVideo
        :videoUrl="itemDetail.mediaurl"
        v-if="itemDetail.mediaurl"
        height="4rem"
        fit="contain"
      ></mVideo>
      <VanImage :src="itemDetail.icon" style="width: 7.5rem;height:3.15rem;" v-else></VanImage>
      <Panel class="header" :title="itemDetail.title">
        <CellGroup :border="false">
          <Cell title="开始时间" icon="clock-o">
            {{
            itemDetail.start_time
            }}
          </Cell>
          <Cell title="截止时间" icon="clock-o">{{ itemDetail.end_time }}</Cell>
          <Cell
            title="投票开始时间"
            v-if="itemDetail.type == 4 && itemDetail.vote_start_time"
            icon="clock-o"
          >{{ itemDetail.vote_start_time }}</Cell>
          <Cell
            title="投票截止时间"
            v-if="itemDetail.type == 4 && itemDetail.vote_end_time"
            icon="clock-o"
          >{{ itemDetail.vote_end_time }}</Cell>
          <Cell title="联系方式" icon="contact" v-if="itemDetail.contact && itemDetail.contact!=0">
            {{
            itemDetail.contact
            }}
          </Cell>
          <Cell
            title="活动规程"
            icon="todo-list-o"
            is-link
            v-if="itemDetail.rules"
            @click="show = true"
          ></Cell>
        </CellGroup>
      </Panel>

      <div class="float" v-if="(itemDetail.add_draw>0 || itemDetail.activity_id) && sports_id != 10020">
        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220830/1661862318/368107.png" @click="godraw" alt="" >
      </div>

      <Popup v-model="show" closeable position="bottom" :style="{ height: '100%' }">
        <div class="vhtml" v-html="itemDetail.rules"></div>
      </Popup>

      <Panel title="要点" v-if="itemDetail.type != 4">
        <div
          v-html="itemDetail.content"
          :class="[isshow ? 'vhtml mt' : 'vhtml']"
          style="font-size: 14px;padding:.2rem .3rem .2rem;"
        ></div>
				<div class="myArrow" v-if="isshow" @click="lookMore">
					<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220623/1655975535-62b42e6f8a501.png"/>
					<span>展示更多</span>
				</div>
				<div class="myArrow" v-if="isshow == false" @click="lookMore2">
					<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20220623/1655976039-62b430673376c.png"/>
					<span>收起</span>
				</div>
      </Panel>
    </div>
    <Footbar>
      <Cell slot="footbar" v-if="itemDetail && itemDetail.register_type == 1">
        <Button
          v-if="itemDetail.today_state !== 1"
          round
          type="primary"
          block
          :disabled="itemDetail.disabled"
          :color="buttonColor"
          @click="godetail"
        >{{ itemDetail.tips }}</Button>
        <Button
          v-else
          round
          type="primary"
          block
          :color="buttonColor"
          :to="{ name: 'sportsResult', params: this.$route.params }"
        >参赛详情</Button>
      </Cell>

      <Cell slot="footbar" v-else>
        <Button
          v-if="itemDetail.register_type == 2"
          round
          type="primary"
          block
          :color="buttonColor"
          :url="itemDetail.register_type_value"
        >立即参与</Button>
        <Button
          v-if="itemDetail.register_type == 3"
          round
          type="primary"
          block
          :color="buttonColor"
          @click="openImg(itemDetail.register_type_value)"
        >立即参与</Button>
        <Button
          v-if="itemDetail.register_type == 6"
          round
          type="primary"
          block
          :color="buttonColor"
          @click="jumpwx(itemDetail.register_type_value)"
        >立即参与</Button>
        <Button
          v-if="itemDetail.register_type == 4"
          round
          type="primary"
          block
          :color="buttonColor"
          @click="jumpMp(itemDetail.register_type_value)"
        >立即参与</Button>
      </Cell>
    </Footbar>
    <van-dialog v-if="itemDetail.register_type == 3" v-model="show" title="长按跳转">
      <div class="img-area">
        <img :src="itemDetail.register_type_value" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import moment from "moment";
import mVideo from "@/components/mVideo/index";
import Footbar from "@/components/footbar/index";
import { Empty, Panel, Cell, Button, CellGroup, Image, Popup } from "vant";
import "./index.less";
import imgurl from "@/assets/img/common/default.png";
import { Base64 } from "js-base64";
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters(["getOnlyUserInfo"]),
    imgurl() {
      return imgurl;
    },
    buttonColor() {
      let detail = this.detail;
      if (!detail) return "#ccc";
      return `${detail.tabstyle[0]["color"]}`;
    },
  },
  components: {
    mVideo,
    Empty,
    Panel,
    Cell,
    Button,
    CellGroup,
    Footbar,
    VanImage: Image,
    Popup
  },
  props: ["item_sub_id", "sports_id",'taskid'],
  data() {
    return {
      show: false,
      detail: "",
      itemDetail: "",
      joinList: [],
      acshow: false,		
			isshow: true,
    };
  },
  methods: {
    ...mapMutations(["toggleShowFill"]),
		lookMore(){
			this.isshow = false
		},
		lookMore2(){
			this.isshow = true
		},
    godetail() {
      // this.$api.sports.getTastAction({taskid: this.taskid,sportsid: this.sports_id}).then(res=>{
      //   if(res.status==200) {
      //     this.$router.replace({name: 'xhjoin', params: {item_sub_id: this.item_sub_id,sports_id:this.sports_id,signtype:this.itemDetail.signtype,taskid: this.taskid} })
      //   }
      // })
      this.$router.replace({name: 'xhjoin', params: {item_sub_id: this.item_sub_id,sports_id:this.sports_id,signtype:this.itemDetail.signtype,taskid: this.taskid} })
    },
    jumpwx(value) {
      wx.miniProgram.navigateTo({
        url: value,
      });
    },
    jumpMp(value) {
      let jump = {
        appId: value
      }
      value = Base64.encodeURI(JSON.stringify(jump));
      //跳转小程序 webview无法直接跳转外部小程序 需要通过当前小程序中转
      wx.miniProgram.navigateTo({
        url: `/pages/jumpmp/index?jumpinfo=${value}`,
      });
    },
    godraw() {
      this.$router.push({name:'luckdraw',params: {acid:this.itemDetail.add_draw>0?this.itemDetail.add_draw:this.itemDetail.activity_id}})
    },
    openImg(url) {
      wx.previewImage({
        current: "", // 当前显示图片的http链接
        urls: [url], // 需要预览的图片http链接列表
      });
    },
    init: function () {
      this.$toast.loading({
        duration: 0,
      });
      let params = { cpgid: this.item_sub_id };
      Promise.all([
        this.$api.sports.sportsMain(this.sports_id),
        this.$api.sports.getComparegame(params),
      ]).then(
        (res) => {
          let { bgstyle, id, tabstyle, introstyle, title } = res[0].data;
          try {
            bgstyle = JSON.parse(bgstyle);
            tabstyle = JSON.parse(tabstyle);
            introstyle = JSON.parse(introstyle);
          } catch (e) {
            console.error(e);
          }
          this.detail = { id, bgstyle, tabstyle, introstyle, title };
          this.joinList = Object.assign([], res[1]["data"]["list"]);
          delete res[1]["data"]["list"];
          let { start_time, end_time, sex_limit, age_limit,type } = res[1]["data"];
          start_time = moment(start_time).valueOf();
          end_time = moment(end_time).valueOf();
          var sys_time = res[1]["sys_time"] * 1000;
          let tips,
            disabled = true;
          if (sys_time < start_time) {
            tips = "活动未开始";
          } else if (sys_time > end_time) {
            if(type==4) {
              tips = "上传已结束";
            } else {
              tips = "活动已结束";
            }            
          } else {
            tips = "立即参与";
            disabled = false;
          }
          this.itemDetail = Object.assign(res[1]["data"], { tips, disabled });
          this.$toast.clear();
          //判断 是否需要 限制性别 或生日 如果需要则要填写信息
          if (+sex_limit !== 0 || +age_limit !== 0) {
            let { name, phone, id_number, gid } = this.getOnlyUserInfo;

            if (!!name && !!phone && !!id_number) {
            } else {
              //需要补全信息
              this.toggleShowFill(true);
              return;
            }
          }
        },
        () => {
          this.$toast.clear();
        }
      );
    },
  },
  mounted() {
    this.init();
    this.cf.wxShareConf();
    window.localStorage.setItem("getPath", '/xh/task/'+this.taskid+'/'+this.sports_id);
  },
};
</script>

<style scoped>
.html >>> img {
  max-width: 100%;
}

.img-area {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-area img {
  max-width: 100%;
}
</style>
